<template>
  <div>
     <h5 class="text-center">
       {{computeCaption(fields_en['please_fill_out_information'], $store.state.lang.value.toLowerCase()) }}
      </h5>
    <div v-if="$store.state.results.site.allow_results">
      <MinimalIdentityCheck :allowName="true" :nameRequired="true" :allowCode="true" :codeRequired="true" :allowDob="true" :dobRequired="true" :allowPhone="false" :phoneRequired="false" ref="minimalIdentityCheck"/>
      <div class="row">
        <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <small class="text-danger" v-show="errorData">{{computeCaption(errorData, this.$store.state.lang.value.toLowerCase())}}</small>
          </div>
        </div>
      </div>
    </div>
    <div v-else>
      <p class="text">Please contact your doctor for your results!</p>
    </div>
  </div>
</template>
<script>
  import {mapFields} from 'vee-validate'
  import {DatePicker} from 'element-ui'
  import axios from 'axios'
  import {FormatterUtils} from '../../../../../utils/Formatter.js'
  import {CheckResults} from '../../../../../utils/CheckResults.js'
  import {ValidationUtils} from '../../../../../utils/Validation.js'
  import MinimalIdentityCheck from '../../Utils/Sections/MinimalIdentityCheck.vue'
  import {TranslationsUtils} from '../../../../../utils/Translations'
  import {PatientInfoUtils} from '../../../../../utils/PatientInfo'
//  PATIENT NAME
//  PATIENT ADDRESS
//  PATIENT SEX
//  PATIENT DOB
//  PATIENT CODE
//  PATIENT EMAIL ADDRESS
//  PATIENT INSURANCE DETAILS
  export default {
    components: {
      [DatePicker.name]: DatePicker,
      MinimalIdentityCheck
    },
    mixins: [FormatterUtils, ValidationUtils, CheckResults, TranslationsUtils, PatientInfoUtils],
    data () {
      return {
        skip_security_code: this.isTrue(this.$store.state.configs.SKIP_SECURITY_CODE),
        errorData: '',
        model: {
          firstName: '',
          lastName: '',
          dob: '',
          code: this.$route.query.confirmation_number
        },
        validatedSectionClass: '',
        fields_en: {
          please_fill_out_information: 'Please fill out the information to be able to retrieve your results'
        },
        modelValidations: {
          siteCode: {
            required: true
          }
        }
      }
    },
    methods: {
      async validate () {
        let info = await this.getPatientInfo()
        let minimalIdentityCheckValues = await this.$refs.minimalIdentityCheck.validate()
        if (minimalIdentityCheckValues) {
          if (minimalIdentityCheckValues.dob !== undefined && minimalIdentityCheckValues.dob !== '') {
            this.model.dob = minimalIdentityCheckValues.dob
          }
          if (minimalIdentityCheckValues.dob_pretty !== undefined && minimalIdentityCheckValues.dob_pretty !== '') {
            this.model.dob_pretty = minimalIdentityCheckValues.dob_pretty
          }
          if (minimalIdentityCheckValues.firstName !== undefined && minimalIdentityCheckValues.firstName !== '') {
            this.model.firstName = minimalIdentityCheckValues.firstName
          }
          if (minimalIdentityCheckValues.lastName !== undefined && minimalIdentityCheckValues.lastName !== '') {
            this.model.lastName = minimalIdentityCheckValues.lastName
          }
          if (minimalIdentityCheckValues.code !== undefined && minimalIdentityCheckValues.code !== '') {
            this.model.code = minimalIdentityCheckValues.code
          }
        } else {
          return false
        }
        return new Promise((resolve, reject) => {
          this.model['send_method_email'] = this.isTrue(this.$store.state.configs.SECURITY_CODE_BY_EMAIL)
          this.model['send_method_text'] = this.isTrue(this.$store.state.configs.SECURITY_CODE_BY_TEXT)
          this.model['site_code'] = this.$store.state.results.site.site_code
          this.model['info'] = info
          axios.post(process.env.SERVER_URI + '/check_user_data', this.model)
          .then(async (response) => {
            if (response.data === false) {
              this.errorData = 'Invalid Data!'
              reject(new Error('Invalid Data!'))
            } else {
              this.errorData = ''
              this.$store.state.results.user = response.data
              if (!this.$store.state.configs.ALLOW_RESULTS_DISCLAIMER) {
                if (this.skip_security_code) {
                  await this.getResults(this.model.firstName, this.model.lastName)
                } else {
                  if (!(this.security_code_by_text && this.security_code_by_email)) {
                    let sendMethod
                    if (this.security_code_by_text) {
                      this.$store.state.results.user['sendTo'] = this.$store.state.results.user.phone
                      sendMethod = 'phone'
                    } else {
                      this.$store.state.results.user['sendTo'] = this.$store.state.results.user.email
                      sendMethod = 'email'
                    }
                    let form = {
                      code: this.$store.state.results.user.code,
                      send_method: sendMethod
                    }
                    await this.generateSecurityCode(form)
                  }
                }
              }
            }
            resolve(true)
          }).catch(() => {
            this.errorData = 'Invalid Data or server issues!'
            reject(new Error('Invalid Data or server issues!'))
          })
        })
      }
    },
    computed: {
      ...mapFields(['siteCode'])
    }
  }
</script>
<style scoped>

>>> .el-select--large{
      width: 100%;
    }

  h5{
    margin-bottom: 25px;
  }

  .text{
    text-align: center;
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Results/Wizard/Data.vue